import { Injectable } from '@angular/core';
import { NativeWindowService } from './native-window.service';
import { SocketService } from './socket.service';
import { DbService } from './db.service';
import { LocaleService } from './locale.service';
import { TableExporterService } from './table-exporter.service';

//import { Http, Headers, URLSearchParams, RequestMethod, RequestOptions, Response, ResponseContentType } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import 'rxjs/Rx';
import * as _ from 'lodash';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CommonService {
	private nativeWindowService: NativeWindowService;
	private socket: SocketService;
	private formatter: LocaleService;
	private dbService: DbService;
	private tableExporter: TableExporterService;
	private httpClient: HttpClient;
	private router: Router;

	public nextStep: any = {
		preselected: '',
		locked: false,
		idStatoAttuale: '',
		idStato: '',
		nomeStato: '',
		codiceStato: '',
		uids: [],
		comuneId: '0',
		nomeComune: '',
		numPrat: 0,
		primoAtto: '',
		ultimoAtto: ''
	};

	constructor(nativeWindowService: NativeWindowService, socket: SocketService, formatter: LocaleService, dbService: DbService, tableExporter: TableExporterService, httpClient: HttpClient, router: Router) {
		console.log("SRV|COMMON - ALIVE!", socket);
		this.nativeWindowService = nativeWindowService;
		this.socket = socket;
		this.formatter = formatter;
		this.dbService = dbService;
		this.tableExporter = tableExporter;
		this.httpClient = httpClient;
		this.router = router;
		this.nextStep = {
			preselected: '',
			locked: false,
			idStatoAttuale: '',
			idStato: '',
			nomeStato: '',
			codiceStato: '',
			uids: [],
			comuneId: '0',
			nomeComune: '',
			numPrat: 0,
			primoAtto: '',
			ultimoAtto: ''
		};
	}

	getNativeWindow(){
		return this.nativeWindowService;
	}

	getSocket(){
		/*if(!this.socket){
			console.log("SRV|COMMON - START SOCKET!");
			this.socket.startSocket(this.dbService.serverUrl, this.dbService.serverPort);
		}*/
		return this.socket;
	}

	getLocale(){
		return this.formatter;
	}

	getDB(){
		return this.dbService;
	}

	getHttpClient(){
		return this.httpClient;
	}

	getRouter(){
		return this.router;
	}

	readDatabaseResponse(requestType: any, data: any){
		let resData = JSON.parse(data);
		if(!resData["esito"])
			console.log("resData", resData);
		switch (requestType) {
			case 'insert':
				return resData["id"];
			case 'update':
			case 'delete':
				return resData;
			default:
				return resData["records"];
		}
	}

	exportCsv(filename: string, data: any){
		this.tableExporter.toCsv(filename, data);
	}

	titleCase(str) {
		str = str.toLowerCase().split(' ');                // will split the string delimited by space into an array of words

		for(var i = 0; i < str.length; i++){               // str.length holds the number of occurrences of the array...
		  str[i] = str[i].split('');                    // splits the array occurrence into an array of letters
		  str[i][0] = str[i][0].toUpperCase();          // converts the first occurrence of the array to uppercase
		  str[i] = str[i].join('');                     // converts the array of letters back into a word.
		}
		return str.join(' ');                              //  converts the array of words back to a sentence.
	}

	capitalize(text: any){
		let result = String(text);
		if(result){
			result = result.toLowerCase();
			result = result[0].toUpperCase() + result.substr(1);
		}
		return result;
	}

	getMin(array, attrib, initialValue){
		return array.reduce(function(prev, curr){
			if(!prev)
				return curr;
			if(!curr)
				return prev;
			return prev[attrib] < curr[attrib] ? prev : curr;
		}, initialValue);
	}

	getMax(array, attrib, initialValue){
		return array.reduce(function(succ, curr){
			if(!succ)
				return curr;
			if(!curr)
				return succ;
			return succ[attrib] > curr[attrib] ? succ : curr;
		}, initialValue);
	}

	sortArray(array, field){
		console.log("SRV|COMMON - sortArray pre", array);
		array.sort(
			(leftSide, rightSide) => {
				//console.log("SRV|DS - sortArray", leftSide[field], rightSide[field]);
				if(leftSide[field] < rightSide[field])
					return -1;
				if(leftSide[field] > rightSide[field])
					return 1;
				return 0;
			}
		);
		console.log("SRV|COMMON - sortArray post", array);
		return array;
	}
}
